import { Link } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'

type AuditorCycleBreadcrumbLink = {
  label: string
  to: string
  params: Record<string, string>
}

type AuditorCycleBreadcrumbCurrent = {
  label: string
  current: true
}

export type AuditorCycleBreadcrumbItem =
  | AuditorCycleBreadcrumbLink
  | AuditorCycleBreadcrumbCurrent

type AuditsHomeRoute =
  | '/workspaces/$workspaceId/audits'
  | '/workspaces/$workspaceId/auditor-center'

interface AuditorCycleBreadcrumbProps {
  workspaceId: string
  auditsHomeRoute: AuditsHomeRoute
  items: AuditorCycleBreadcrumbItem[]
}

export function AuditorCycleBreadcrumb({
  workspaceId,
  auditsHomeRoute,
  items,
}: AuditorCycleBreadcrumbProps) {
  return (
    <div className='flex min-w-0 items-center gap-1.5 text-[13px]'>
      <Link
        to={
          auditsHomeRoute === '/workspaces/$workspaceId/auditor-center'
            ? '/auditor-center'
            : auditsHomeRoute
        }
        params={{ workspaceId }}
        preload={false}
        className='text-text-body transition-colors hover:text-text-secondary'
      >
        Audits
      </Link>
      {items.map((item, index) => (
        <span
          key={`${item.label}-${index}`}
          className='flex min-w-0 items-center gap-1.5'
        >
          <ChevronRight className='size-3 shrink-0 text-text-placeholder' />
          {'current' in item ? (
            <span className='max-w-[200px] truncate font-semibold text-foreground'>
              {item.label}
            </span>
          ) : (
            <Link
              to={item.to}
              params={item.params}
              preload={false}
              className='text-text-body transition-colors hover:text-text-secondary'
            >
              {item.label}
            </Link>
          )}
        </span>
      ))}
    </div>
  )
}
